export enum DmoInvitationStatus {
  ACTIVE = "active",
  EXPIRED = "expired",
  CANCELLED = "cancelled",
  COMPLETED = "completed",
}

export enum DmoRegistrationStatus {
  ACTIVE = "1",
  INACTIVE = "2",
}

export interface DMOInvitation {
  id: string;
  email: string;
  status?: DmoInvitationStatus;
  created_at?: string;
  updated_at?: string;
  expires_at?: string;
  [key: string]: unknown;
}

export interface DMOInvitationListQueryParams {
  page?: number;
  limit?: number;
  search?: string;
  status?: DmoInvitationStatus;
}

export interface CreateDMOInvitationPayload {
  email: string;
  expires_at?: string;
}

export interface RegionOperator {
  id: string;
  name: string;
  email: string;
}

export interface HarborDetail {
  id: string;
  name: string;
  description: string | null;
  status: number;
  facilities: string[];
  amenities: string[] | null;
  business_hours: Record<string, { open: string; close: string }>;
  logo: string | null;
  fairway_map: string | null;
  media: string[];
}

export interface RegionDetail {
  id: string;
  name: string;
  status: number;
  region_operator: RegionOperator;
  harbors: HarborDetail[];
}

export interface DMORegisteredProfile {
  id: string;
  user_id?: string;
  organisation_name: string;
  organisation_type?: string;
  contact_email: string;
  linked_regions?: string[] | string;
  linked_region_details?: RegionDetail[];
  public_homepage?: string | null;
  description?: string;
  language?: string;
  status?: number | string;
  created_at?: string;
  email?: string;
  name?: string;
  legal_acceptance_summary?: import('./legal-compliance.types').LegalAcceptanceSummary | null;
  [key: string]: unknown;
}

export interface DMORegisteredListQueryParams {
  user_id?: string;
  search?: string;
  page?: number;
  limit?: number;
  language?: string;
  "x-session-id"?: string;
  "x-location-name"?: string;
  "x-latitude"?: number;
  "x-longitude"?: number;
}

export interface DMORegisterForm {
  organisation_name: string;
  organisation_type: string;
  contact_email: string;
  linked_regions: string;
  public_homepage: string;
  description: string;
  language: string;
  email: string;
  name: string;
  has_accepted_terms: boolean;
  sendTermsPdf: boolean;
}
